import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { ContentLayout } from '../../components/layouts/ContentLayout';
import { useParticipantsFilterQuery } from '../../graphql/hooks/useParticipantsQuery';
import { useParticipantsFilter } from '../../hooks/useParticipantsFilter';
import { usePermission } from '../../hooks/usePermission';
import { ParticipantCreateModal } from './ParticipantCreateModal';
import { ParticipantsActionMenu } from './ParticipantsActionMenu';
import { ParticipantsFilterControls } from './ParticipantsFilterControls';
import { ParticipantsTable } from './ParticipantsTable';

export const Participants = () => {
  const filter = useParticipantsFilter();

  const createParticipantPermission = usePermission('create', 'participant');

  const { isLoading, error, participants, refetch, pagination, rowSelection } =
    useParticipantsFilterQuery(filter);

  return (
    <ContentLayout
      headerContent={
        <ChakraV3.HStack align='start'>
          <ChakraV3.Heading size='3xl' fontWeight='bold'>
            Participants
          </ChakraV3.Heading>
          <ChakraV3.Spacer />
          <ChakraV3.HStack>
            <ChakraV3.Button
              onClick={() => showModal(ParticipantCreateModal)}
              disabled={!createParticipantPermission}
              colorPalette='brand'
              size='sm'
            >
              <FaPlus />
              Add Participant
            </ChakraV3.Button>
            <ParticipantsActionMenu filter={filter} size='sm' />
          </ChakraV3.HStack>
        </ChakraV3.HStack>
      }
    >
      <ChakraV3.Stack gap={4} px={6}>
        <ParticipantsFilterControls filter={filter} />
        <ParticipantsTable
          error={error}
          isLoading={isLoading}
          participants={participants}
          refetch={refetch}
          pagination={pagination}
          rowSelection={rowSelection}
        />
      </ChakraV3.Stack>
    </ContentLayout>
  );
};
